import * as XLSX from 'xlsx';

function trimCell(value) {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim();
}

function rowToMap(headers, cols) {
  const record = {};

  headers.forEach((header, index) => {
    const key = trimCell(header);
    if (!key) {
      return;
    }

    record[key] = index < cols.length ? trimCell(cols[index]) : '';
  });

  return record;
}

/**
 * Mirrors uae-document-ingestion-svc ResolveDocumentNumberFromPayload.
 */
export function resolveDocumentNumberFromPayload(payload) {
  const groupHeader = trimCell(payload.document_group_key);
  if (!groupHeader) {
    return '';
  }

  return trimCell(payload[groupHeader]);
}

/**
 * Mirrors uae-document-ingestion-svc ApplyDocumentNumberToPayload.
 */
export function applyDocumentNumberToPayload(payload) {
  const resolved = resolveDocumentNumberFromPayload(payload);
  if (!resolved) {
    return;
  }

  payload.document_number = resolved;
}

/**
 * Build document payload from sheet rows — mirrors uae-document-ingestion-svc buildPayloadFromRows + ApplyDocumentNumberToPayload.
 * Header columns from the first row are always hoisted to the root so paths like $.invoice_number work
 * for multi-line invoices (rows[] holds every line).
 */
export function buildDocumentPayload(rows) {
  const payload = { rows };

  if (rows.length > 0) {
    Object.assign(payload, rows[0]);
  }

  applyDocumentNumberToPayload(payload);

  return payload;
}

/**
 * Parse a single-document XLSX workbook into the connector preview payload shape.
 *
 * @param {ArrayBuffer} arrayBuffer
 * @returns {{ payload: object, headers: string[] }}
 */
export function parseXlsxSample(arrayBuffer) {
  let workbook;
  try {
    workbook = XLSX.read(arrayBuffer, { type: 'array' });
  } catch (err) {
    throw new Error(`Failed to open XLSX file: ${err.message}`);
  }

  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    throw new Error('XLSX has no sheets');
  }

  const sheet = workbook.Sheets[sheetName];
  const rawRows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', raw: false });

  if (!rawRows.length) {
    throw new Error('XLSX sheet is empty');
  }

  const headers = (rawRows[0] || []).map((cell) => trimCell(cell));
  const dataRows = rawRows.slice(1).filter((row) => row.some((cell) => trimCell(cell) !== ''));

  if (!dataRows.length) {
    throw new Error('No data rows in XLSX');
  }

  const rows = dataRows.map((row) => rowToMap(headers, row));

  return {
    headers,
    payload: buildDocumentPayload(rows),
  };
}
